import { Component, inject, OnInit, signal } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { appLanguages } from './app.languages';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet],
  templateUrl: './app.html',
  styleUrl: './app.scss'
})
export class App implements OnInit {
  protected readonly title = signal('gal-college-triage-client');
  readonly translate = inject(TranslateService);

  ngOnInit() {
    this.translate.onLangChange.subscribe((event) => {
      const lang  = event.lang as keyof typeof appLanguages;
      const dir   = appLanguages[lang].dir;

      document.getElementsByTagName("html")[0].setAttribute('lang', lang);
      document.getElementsByTagName("body")[0].setAttribute('dir', dir);
    });
  }
}
